import { ThemeProvider } from "styled-components";
import theme from "./config/theme";
import { RouterProvider } from "react-router-dom";
import appRouter from "./routers/appRouter";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={appRouter} />
    </ThemeProvider>
  );
}

export default App;
